export const ADDIN_FEATURES = {
  disableAutoInsertSignatures: {
    label: 'label.DISABLE_AUTO_INSERT_SIGNATURES',
    inverted: true
  },
  defaultSignatureMode: {
    label: 'label.DEFAULT_SIGNATURE_MODE'
  },
  disableDynamicFields: {
    label: 'label.DYNAMIC_FIELDS',
    inverted: true
  },
  disableFieldEdits: {
    label: 'label.FIELD_EDITS',
    inverted: true
  },
  disableFromSwitching: {
    label: 'label.FROM_SWITCHING',
    inverted: true
  },
  ignoreblankmergefields: {
    label: 'label.IGNORE_BLANK_MERGE_FIELDS'
  },
  mergeParams: {
    label: 'label.MERGE_PARAMS'
  },
  enableMultipleSignatures: {
    label: 'label.MULTIPLE_SIGNATURES'
  },
  disablePlainTextPreview: {
    label: 'label.PLAIN_TEXT_PREVIEW',
    inverted: true
  },
  disableRemoveDefaultSignature: {
    label: 'label.REMOVE_DEFAULT_SIGNATURE',
    inverted: true
  },
  signatureFieldsOnly: {
    label: 'label.SIGNATURE_FIELDS_ONLY'
  },
  userControlledSettings: {
    label: 'label.USER_CONTROLLED_SETTINGS'
  },
  enableVisualPreview: {
    label: 'label.VISUAL_PREVIEW'
  }
};
